
import { CSSProperties } from "@mui/material";

export const CircularProgressStyle  : CSSProperties = {
    top: 0, 
    left: 0, 
    bottom: 0, 
    right: 0,
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}